import { render } from "./narasi.vue?vue&type=template&id=7cb1787f&scoped=true"
import script from "./narasi.vue?vue&type=script&lang=js"
export * from "./narasi.vue?vue&type=script&lang=js"

import "./narasi.vue?vue&type=style&index=0&id=7cb1787f&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-7cb1787f"

export default script